/**
 * BLOCK - COUNTRY LANGUGAGE SELECTOR
 */

if (!customElements.get('localization-form')) {
  customElements.define('localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        
        this.elements = {
          input: this.querySelector('input[name="country_code"], input[name="locale_code"]'),
          select: this.querySelector('select.localization-selector')
        };

        this.setupEventListeners();   
      }
    
      // Creates the event listeners
      setupEventListeners() {
        if (this.elements.select !== null) this.elements.select.addEventListener('change', this.onItemChange.bind(this));
        this.querySelectorAll('.dropdown__link').forEach((element) => element.addEventListener('click', this.onItemClick.bind(this)));  
      }
    
      // On changing on a localization form select
      onItemChange(event) {
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.value;
        if (form) form.submit();
      }
    
      // On clicking on a localization form dropdown option
      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }
    }
  );
}